export default __webpack_public_path__ + "static/media/Sterling-Logo_.862c0691.svg";